import { render } from "./SobreNosotros.vue?vue&type=template&id=8bfa31aa&scoped=true&class=banner"
import script from "./SobreNosotros.vue?vue&type=script&lang=js"
export * from "./SobreNosotros.vue?vue&type=script&lang=js"

import "./SobreNosotros.vue?vue&type=style&index=0&id=8bfa31aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfa31aa"]])

export default __exports__